import React, { useEffect, useState } from 'react'
import ToolButtonImage from '../../images/tool-button.png'
import { AnimatePresence, motion } from 'framer-motion'
import { useWindowScroll, useWindowSize } from 'react-use'
import ExpandedToolButton from '../molecules/ExpandedToolButton'
import { useScrollDirection } from 'react-use-scroll-direction'

const ToolsButton = ({ inverted, onOpenTool, onOpenCollapsedTool }) => {
  const { y: scrollY } = useWindowScroll()
  const { width: windowWidth } = useWindowSize()
  const { isScrollingUp, isScrollingDown } = useScrollDirection()
  const [isOverlayVisible, setOverlayVisible] = useState(false)

  useEffect(() => {
    if (scrollY < 100 && isOverlayVisible) {
      setOverlayVisible(false)
      return
    }

    if (isScrollingDown && isOverlayVisible) {
      setOverlayVisible(false)
      return
    }

    if (isScrollingUp && !isOverlayVisible && windowWidth >= 768) {
      setOverlayVisible(true)
    }
  }, [isScrollingUp, isScrollingDown, scrollY])

  const isExpanded = isOverlayVisible || scrollY < 160

  return (
    <>
      <AnimatePresence exitBeforeEnter>
        {isExpanded ? (
          <>
            <motion.div
              key="expanded-desktop"
              className="hidden md:block"
              initial={{ opacity: 1 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0, y: -50 }}
              transition={{ type: 'tween' }}
            >
              <ExpandedToolButton inverted={inverted} onOpenTool={onOpenTool} />
            </motion.div>
            <motion.div
              key="expanded-mobile"
              className={`fixed bottom-0 left-0 right-0 md:hidden z-[99]`}
              initial={{ y: 240 }}
              animate={{ y: 0 }}
              exit={{ y: 240 }}
              transition={{ type: 'ease' }}
            >
              <ExpandedToolButton onOpenTool={onOpenTool} />
            </motion.div>
          </>
        ) : (
          <motion.button
            key="not-expanded"
            type="button"
            className="fixed bg-white rounded-full bottom-3 md:top-8 right-3 md:bottom-auto md:right-8 z-[100] w-[70px] h-[70px] flex items-center justify-center shadow-box"
            onClick={onOpenCollapsedTool}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
          >
            <img src={ToolButtonImage} alt="" className="w-12 h-auto" />
          </motion.button>
        )}
      </AnimatePresence>
    </>
  )
}

export default ToolsButton
